import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Endpoint } from '@/Config/api/endpoint';
import { QueryKey } from '@/Config/api/queryKey';
import { ActionsApi } from '@/Domain/api/Action/ApiAction/Actions.api';
import { ActionDto } from '@/Domain/api/Action/dto/Action.dto';
import { RemoteMcpDto } from '@/Domain/api/Action/dto/RemoteMCP.dto';

export const useActivateRemoteMcp = (action: ActionDto) => {
  const { t } = useTranslation('remote_mcp');
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationKey: [Endpoint.actions.basic.patch],
    mutationFn: ({ is_active, id }: { is_active: boolean; id: number }) =>
      ActionsApi.update(id, { is_active: is_active }),
    onSuccess: (updatedAction) => {
      void queryClient.setQueryData(
        [QueryKey.actions.remoteMcp.get, updatedAction.id],
        (prev: RemoteMcpDto) => ({ ...prev, ...updatedAction }),
      );
      queryClient.invalidateQueries({ queryKey: ['subscription'] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.actions.basic.health] });

      queryClient.setQueryData([QueryKey.actions.basic.list], (prev: ActionDto[]) =>
        prev.map((actionItem) =>
          actionItem.id === action.id
            ? { ...actionItem, is_active: !actionItem.is_active }
            : actionItem,
        ),
      );

      if (updatedAction.is_active) {
        toast.info(t('toast.active_enabled'));
      } else {
        toast.info(t('toast.active_disabled'));
      }
    },
  });

  const handleActive = (isActive: boolean) => {
    mutation.mutate({ is_active: isActive, id: action.id });
  };

  return {
    handleActive,
  };
};
